module.exports = __webpack_public_path__ + "static/media/discover.cc165403.svg";